module.exports = __webpack_public_path__ + "img/logo-winwin.dc4ce072.svg";